<template>
  <div class="locator__place-extended-info" ref="extendedInfoContainer" style="display: none">
    <div class="locator__place-extended-first-row">
      <button class="locator__place-extended-back-btn" @click.stop.prevent="hide">
        <svg
          width="48px"
          height="48px"
          viewBox="0 0 48 48"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="desktop" stroke-width="0" fill="none" fill-rule="evenodd">
            <g id="opticDetails" transform="translate(-185.000000, -231.000000)">
              <g id="iconBack" transform="translate(185.000000, 231.000000)">
                <!--<rect id="Rectangle" stroke="#E9E9E9" x="0.5" y="0.5" width="47" height="47"></rect>-->
                <path
                  d="M14,29 L28,29 C31.866,29 35,25.866 35,22 C35,18.134 31.866,15 28,15 L21,15"
                  id="Stroke-5"
                  stroke="inherit"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <polyline
                  id="Stroke-7"
                  stroke="inherit"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  points="19 24 14 29 19 34"
                />
              </g>
            </g>
          </g>
        </svg>
      </button>
      <div class="badges">
        <place-promotion
          class="badge"
          v-for="badge in badgePromotionsFirst"
          v-bind:key="badge.id"
          :promotion="badge"
          :institutionData="institutionData"
        ></place-promotion>

        <!--<img-->
        <!--v-for="badge in badgePromotions"-->
        <!--:src="badge.logo"-->
        <!---->
        <!--&gt;-->
        <div
          class="dropdown dropdown-main-list is-right is-hoverable"
          v-if="badgePromotionsDropdown.length"
        >
          <div
            @mouseover="isDropdownActive = true"
            @mouseleave="isDropdownActive = false"
            class="dropdown-trigger"
            :aria-controls="'dropdown-menu'+institutionData.id"
          >
            <span class="dropdown-text">akcje specjalne</span>
            <span v-if="!isDropdownActive">
              <i class="arrow black down"></i>
            </span>
            <span v-if="isDropdownActive">
              <i class="arrow black down"></i>
            </span>
          </div>
          <div class="dropdown-menu" :id="'dropdown-menu'+institutionData.id" role="menu">
            <div class="dropdown-content top-bar-color">
              <div class="dropdown-item">
                <div class="locator__place-promo-icons">
                  <template v-for="promotion in badgePromotionsDropdown">
                    <place-promotion
                      :promotion="promotion"
                      :institutionData="institutionData"
                      :dropdown-id="institutionData.id"
                    ></place-promotion>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div style="width: 100px; height: 32px; background: blue"></div>-->
    </div>

    <address class="locator__place-extended-info-address">
      <div class="address">
        <h3 class="locator__place-extended-info-place-name" v-if="name">{{ name }}</h3>
        <span
          class="locator__place-extended-info-address-part"
          v-if="streetWithNumber"
        >{{ streetWithNumber }}</span>
        <span
          class="locator__place-extended-info-address-part"
          v-if="postalWithCity"
        >{{ postalWithCity }}</span>
        <a
          target="_blank"
          v-bind:href="website.link"
          class="locator__place-extended-info-website"
          v-if="website.title"
        >{{ website.title }}</a>
      </div>
    </address>

    <div @click="closeOther()" v-if="eConferenceAvailable">
      <hr />
      <h3 class="locator__place-extended-title">{{ $t('e_conference') }}</h3>
      <e-conference :institutionId="institutionId" :institutionName="name" :email="email" :econference="eConferenceAvailable"></e-conference>
    </div>

    <div @click="closeOther()" v-if="safeAppointmentAvailable">
      <hr />
      <h3 class="locator__place-extended-title">{{ $t('safe_appointment') }}</h3>
      <safe-appointment :institutionId="institutionId" :institutionName="name" :email="email" :safeAppointment="safeAppointmentAvailable" :city="this.institutionData.institution.city"></safe-appointment>
    </div>

    <template v-if="promotions.length && promotionsHasAttachment">
      <hr />
      <div class="locator__place-extended-download">
        <h3 class="locator__place-extended-title">{{ $t('to_download') }}</h3>

        <template
          v-for="promotion in promotions"
          v-if="promotion.attachment_name && !promotion.as_badge"
        >
          <a
            v-if="promotion.attachment_url"
            target="_blank"
            class="btn"
            v-bind:href="getPromotionAttachmentUrl(promotion)"
            @click="onPromotionClick"
          >
            <img
              style="display: flex; margin-left: auto; margin-right: 10px"
              :src="promotion.btn_logo"
              alt
            />
            <span style="display: flex; margin-right: auto" v-html="promotion.attachment_name"></span>
          </a>
        </template>
      </div>
    </template>

    <template v-if="telephone || email">
      <hr />

      <div class="locator__place-extended-contact">
        <h3 class="locator__place-extended-title">{{ $t('make_an_appointment') }}</h3>
        <a
          class="btn"
          v-bind:href="'tel:'+ telephone"
          @click="onTelephoneClick"
          v-if="telephone"
          style="position: relative"
        >
          <svg
            width="23px"
            height="23px"
            viewBox="0 0 23 23"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="desktop"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <g
                id="opticDetails"
                transform="translate(-265.000000, -483.000000)"
                stroke="inherit"
                stroke-width="2"
              >
                <path
                  d="M282,497 L279,500 L271,492 L274,489 L269,484 L266,487 C266,496.941 274.059,505 284,505 L287,502 L282,497 L282,497 Z"
                  id="iconPhone"
                />
              </g>
            </g>
          </svg>
          {{ telephone }}
        </a>
        <a class="btn" v-bind:href="'mailto:'+ email" v-if="email" @click="onEmailClick">
          <svg
            width="24px"
            height="20px"
            viewBox="0 0 24 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="desktop"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <g
                id="opticDetails"
                transform="translate(-262.000000, -549.000000)"
                stroke="inhreit"
                stroke-width="2"
              >
                <g id="iconMail" transform="translate(263.000000, 550.000000)">
                  <polyline id="Stroke-291" points="18 4 11 11 4 4" />
                  <polygon id="Stroke-292" points="0 0 22 0 22 18 0 18" />
                  <path d="M6,12 L4,14" id="Stroke-293" />
                  <path d="M16,12 L18,14" id="Stroke-294" />
                </g>
              </g>
            </g>
          </svg>
          {{ email }}
        </a>
      </div>
    </template>

    <div class="locator__place-extended-partners">
      <div
        class="locator__place-extended-partner"
        v-for="partner in partners"
        v-if="partner.logo_url"
      >
        <img v-bind:src="partner.logo_url" alt />
      </div>
    </div>
    <div class="locator__place-share-url copy" @click="onCopyClick">
      <span class="copy-title">Adres wizytówki tego salonu optycznego:</span>
      <span class="ttip">Skopiowano</span>
      <span class="copy__data">{{ shareUrl }}</span>
    </div>
  </div>
</template>

<script>
import { AsYouType } from "libphonenumber-js";
import PlacePromotion from "./placePromotion";
import eConference from "./e-conference";
import EventBus from "../eventBus";
import SafeAppointment from "./safe-appointment";

export default {
  name: "place-info",
  props: [],
  components: {
    SafeAppointment,
    PlacePromotion,
    eConference
  },
  data() {
    return {
      visibleLocal: this.visible || false,
      institutionData: {},
      visible: false,
      isActive: "",
      isDropdownActive: false
    };
  },
  watch: {
    "$store.state.selectedInstitution"(institutionData) {
      this.institutionData = institutionData;
      if (institutionData) {
        this.makeVisible();
      } else {
        this.makeHidden();
      }
    }
  },
  computed: {
    institutionId(){
      if (!this.institutionDataHasInstitution()) return "";
      return  this.institutionData.institution.id
    },
    streetWithNumber() {
      if (!this.institutionDataHasInstitution()) return "";
      let street = this.institutionData.institution.street_name;
      let buildingNumber = this.institutionData.institution.building_number;
      let apartmentNumber = this.institutionData.institution.apartment_number;

      if (!street) return "";
      let streetWithNumber = street + (" " + buildingNumber) || "";
      if (apartmentNumber)
        streetWithNumber = streetWithNumber + "/" + apartmentNumber;

      return streetWithNumber;
    },
    postalWithCity() {
      if (!this.institutionDataHasInstitution()) return "";
      let postalCode = this.institutionData.institution.postal_code;
      if (
        postalCode.length > 2 &&
        postalCode.indexOf("-") < 0 &&
        this.$appLang !== "LT"
      ) {
        postalCode = postalCode.substr(0, 2) + "-" + postalCode.substr(2);
      }
      return postalCode + " " + this.institutionData.institution.city;
    },
    name() {
      if (!this.institutionDataHasInstitution()) return "";
      return this.institutionData.institution.name;
    },
    website() {
      if (!this.institutionDataHasInstitution()) return "";
      let www = this.institutionData.institution.www;
      if (www && www.indexOf("http") > -1) {
        return {
          title: www,
          link: www
        };
      }
      return {
        title: www,
        link: "http://" + www
      };
    },
    telephone() {
      if (!this.institutionDataHasInstitution()) return "";
      let telephone = this.institutionData.institution.telephone_number || "";
      telephone = telephone.replace(/[\D]/, "");
      return new AsYouType("PL").input(telephone);
      // console.log(tel);
      // return telephone;
      // Formatowanie numeru telefonu
      // return this.formatTelephoneNumber(telephone);
    },
    email() {
      if (!this.institutionDataHasInstitution()) return "";
      return this.institutionData.institution.email;
    },
    promotions() {
      if (!this.institutionDataHasPromotion()) return [];
      return this.institutionData.promotions;
    },
    badgePromotions() {
      return this.promotions.filter(promotion => promotion.as_badge);
    },
    badgePromotionsFirst() {
      return this.promotions.filter(
        el =>
          el.hasOwnProperty("as_badge") &&
          el.as_badge &&
          (!el.hasOwnProperty("visible_menu") ||
            (el.hasOwnProperty("visible_menu") && !el.visible_menu))
      );
    },
    badgePromotionsDropdown() {
      return this.promotions.filter(
        el =>
          el.hasOwnProperty("visible_menu") &&
          el.visible_menu
      );
    },
    promotionsHasAttachment() {
      if (!this.institutionDataHasPromotion()) return false;
      for (let promotion of this.promotions) {
        if (promotion.attachment_url && !promotion.as_badge) return true;
      }
      return false;
    },
    partners() {
      if (!this.institutionDataHasInstitution()) return [];
      let partners = false;
      // Specjalny kod dla JZO
      if (this.$siteVariant === 1) {
        partners = this.institutionData.partners.filter(item => item.id === 8);
        // partners = [{logo_url: require('../assets/cnw_partner.svg')}]
      }
      return partners || this.institutionData.partners;
    },
    eConferenceAvailable() {
      let eConference = null;
      for (let promotion in this.promotions) {
        if (!this.promotions[promotion].hasOwnProperty("e_consultation")) {
          continue;
        }

        if (this.promotions[promotion].e_consultation) {
          eConference = {
            button: this.promotions[promotion].hasOwnProperty(
              "e_consultation_button"
            )
              ? this.promotions[promotion].e_consultation_button
              : null,
            tooltip: this.promotions[promotion].hasOwnProperty(
              "e_consultation_tooltip"
            )
              ? this.promotions[promotion].e_consultation_tooltip
              : null
          };
          break;
        }
      }
      return eConference;
    },
    safeAppointmentAvailable() {
      let safeAppointment = null;
      for (let promotion in this.promotions) {
        if (!this.promotions[promotion].hasOwnProperty("safe_appointment")) {
          continue;
        }

        if (this.promotions[promotion].safe_appointment) {
          safeAppointment = {
            button: this.promotions[promotion].hasOwnProperty(
                "safe_appointment_button"
            )
                ? this.promotions[promotion].safe_appointment_button
                : null,
            tooltip: this.promotions[promotion].hasOwnProperty(
                "safe_appointment_tooltip"
            )
                ? this.promotions[promotion].safe_appointment_tooltip
                : null
          };
          break;
        }
      }
      return safeAppointment;
    },
    shareUrl() {
      if (!this.institutionDataHasInstitution() || process.env.VUE_APP_SHARE_URL === undefined) return "";
      return process.env.VUE_APP_SHARE_URL.replace('{ID}', this.institutionData.institution.id)
    }
  },
  methods: {
    shouldShow(statment) {
      return statment != false && statment != null;
    },
    copyToClipboard (element) {
      let copyText = element;
      const input = document.createElement("textarea");
      input.value = copyText.textContent;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      input.remove();
      window.getSelection().removeAllRanges()
    },
    closeOther(){
      EventBus.$emit('CLOSE_OTHER', true)
    },
    onCopyClick(e) {
      let target = event.currentTarget;
      this.copyToClipboard(target.querySelector('.copy__data'));
      target.classList.add('copied');
      setTimeout(() => {
        target.classList.remove('copied');
      }, 2000)
    },
    onTelephoneClick() {
      parent.dataLayer.push({
        telefon: this.telephone,
        nazwasalonu: this.institutionData.institution.name,
        event: "telefon-klik"
      });
    },
    onEmailClick() {
      parent.dataLayer.push({
        mail: this.email,
        nazwasalonu: this.institutionData.institution.name,
        event: "mail-klik"
      });
    },
    onPromotionClick() {
      parent.dataLayer.push({
        nazwasalonu: this.institutionData.institution.name,
        event: "kupon-pobrany"
      });
    },
    institutionDataHasInstitution() {
      if (!this.institutionData) return false;
      if (!this.institutionData.institution) return false;
      return true;
    },
    institutionDataHasPromotion() {
      if (!this.institutionData) return false;
      if (!this.institutionData.promotions) return false;
      return true;
    },
    getPromotionAttachmentUrl(promotionData) {
      if (!promotionData.attachment_url) return "";
      let baseUrl = promotionData.attachment_url;
      baseUrl += "?institution=" + this.institutionData.institution.id;
      return baseUrl;
    },
    hide() {
      this.$store.commit("selectInstitution", null);
      this.makeHidden();
    },
    makeVisible() {
      this.$el.style.display = "flex";
      this.$el.classList.add('locator-extended-visible');
    },
    makeHidden() {
      this.$el.style.display = "none";
      this.$el.classList.remove('locator-extended-visible');
    },
    formatTelephoneNumber(telephone) {
      let formattedNumber = "";
      if (this.isLandline(telephone)) {
        let withCountry = telephone.length > 9;
        formattedNumber = "(" + telephone.substr(0, 2) + ")";

        if (withCountry) {
          formattedNumber += "(" + telephone.substr(2, 2) + ")";
        }

        formattedNumber += " " + telephone.substr(withCountry ? 4 : 2, 3);
        formattedNumber += "-" + telephone.substr(withCountry ? 7 : 5, 2);
        formattedNumber += "-" + telephone.substr(withCountry ? 9 : 7);
      } else {
        for (let i = 0; i < 9; i += 3) {
          formattedNumber += "-" + telephone.substr(i, 3);
        }
        formattedNumber = formattedNumber.substr(1);
      }
      return formattedNumber;
    },
    isLandline(telephone) {
      let prefix = telephone.substring(0, 2);

      return prefix <= 49;
    },
    toggleVisibility() {
      this.isActive = !this.isActive;
    }
  }
};
</script>

<style scoped lang="scss">
.dropdown-trigger {

  display: flex;
  flex-direction: column;
  justify-self: center;
  text-align: center;

  .dropdown-text {
    max-width: 48px;
    font-size: 11px;
  }

  div {
    width: 35px;
    height: 5px;
    background-color: black;
    margin: 6px 0;
  }
}

.hidden {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
</style>
